import { Box, TextField, Typography } from "@mui/material";

const CustomTextBox = ({ label, onChange, value, error, InputProps, inputRef, rows, placeholder, type }) => (
  <Box sx={{ display: "flex", flexDirection: "column", width: "100%", mt: 1.5 }}>
    {label && (
      <Typography sx={{ fontSize: 12, fontWeight: 600, color: error ? "#D33A3A" : "var(--text-3)", mb: 0.5 }}>
        {label}
      </Typography>
    )}
    <TextField
      variant="outlined"
      size="small"
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      error={Boolean(error)}
      InputProps={InputProps}
      inputRef={inputRef}
      placeholder={placeholder}
      type={type}
      multiline={Boolean(rows)}
      rows={rows || undefined}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: 2,
          backgroundColor: "var(--surface)",
          fontSize: 14,
          "& fieldset": { borderColor: "var(--border)" },
          "&:hover fieldset": { borderColor: "var(--text-3)" },
          "&.Mui-focused fieldset": { borderColor: "#2F4858" },
        },
      }}
    />
  </Box>
);

export default CustomTextBox;
